import { type } from "os";
import React, { ReactNode, useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion, useAnimate } from "framer-motion";

export const LoadingAnimation = ({ children, onClick }: any) => {
  const [currentState, setCurrentState] = useState<any>("stateOne");

  useEffect(() => {
    if (currentState === "stateOne") {
      setTimeout(() => {
        setCurrentState("stateTwo");
      }, 700);
    } else if (currentState === "stateTwo") {
      setTimeout(() => {
        setCurrentState("stateThree");
      }, 700);
    } else if (currentState === "stateThree") {
      setTimeout(() => {
        setCurrentState("stateFour");
      }, 700);
    } else {
      setTimeout(() => {
        setCurrentState("stateOne");
      }, 700);
    }
  }, [currentState]);

  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        margin-left: auto;
      `}
    >
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 372 218"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_2)">
          <rect width="372" height="218" rx="24" fill="black" />
          <rect x="-26" y="-29" width="434" height="282" fill="white" />
          <g filter="url(#filter0_f_1_2)">
            <motion.ellipse
              cx="186"
              cy="109"
              rx="43"
              ry="41"
              animate={currentState}
              variants={{
                stateOne: { cx: 186, cy: 109, rx: 47, ry: 46 },
                stateTwo: {
                  cx: 106,
                  cy: 109,
                  rx: 47,
                  ry: 46,
                },
                stateThree: {
                  cx: 186,
                  cy: 109,
                  rx: 47,
                  ry: 46,
                },
                stateFour: {
                  cx: 186,
                  cy: 189,
                  rx: 47,
                  ry: 46,
                },
              }}
              transition={{
                duration: 0.7,
                ease: "easeInOut",
              }}
              fill="black"
            />
            <motion.ellipse
              cx="186"
              cy="109"
              rx="43"
              ry="41"
              animate={currentState}
              variants={{
                stateOne: { cx: 186, cy: 109, rx: 47, ry: 46 },
                stateTwo: {
                  cx: 266,
                  cy: 109,
                  rx: 47,
                  ry: 46,
                },
                stateThree: {
                  cx: 186,
                  cy: 109,
                  rx: 47,
                  ry: 46,
                },
                stateFour: {
                  cx: 186,
                  cy: 29,
                  rx: 47,
                  ry: 46,
                },
              }}
              transition={{
                duration: 0.7,
                ease: "easeInOut",
              }}
              fill="black"
            />
          </g>
          <g
            css={css`
              mix-blend-mode: color-dodge;
            `}
          >
            <rect y="0" width="372" height="217.565" fill="#878787" />
          </g>
          <g
            css={css`
              mix-blend-mode: color-burn;
            `}
          >
            <rect y="0" width="372" height="217.565" fill="black" />
          </g>
          <g
            css={css`
              mix-blend-mode: screen;
            `}
          >
            <motion.rect
              width="372"
              height="217.565"
              transform="translate(0 0.434967)"
              fill="#A29B8B"
              animate={currentState}
              variants={{
                stateOne: { fill: "#A29B8B" },
                stateTwo: {
                  fill: "#FFD550",
                },
                stateThree: {
                  fill: "#A29B8B",
                },
                stateFour: {
                  fill: "#FFD550",
                },
              }}
              transition={{
                duration: 1,
                ease: "linear",
              }}
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_1_2"
            x="-64"
            y="-64"
            width="500"
            height="346"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="32"
              result="effect1_foregroundBlur_1_2"
            />
          </filter>
          <clipPath id="clip0_1_2">
            <rect width="372" height="218" rx="24" fill="white" />
          </clipPath>
        </defs>
      </motion.svg>
    </div>
  );
};
